export default class OnboardingRia {
  constructor() {
    this.onboardedRia = {};
  }
}
